/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Select_SessionInputs */

const en_audit_select_session = /** @type {(inputs: Audit_Select_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select session`)
};

const es_audit_select_session = /** @type {(inputs: Audit_Select_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar sesion`)
};

/**
* | output |
* | --- |
* | "Select session" |
*
* @param {Audit_Select_SessionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_select_session = /** @type {((inputs?: Audit_Select_SessionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Select_SessionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_select_session(inputs)
	return es_audit_select_session(inputs)
});